import * as types from './mutations-type'

export const setRawData = function({commit}, payload) {
    commit(types.RAWDATA, payload)
}

export const setDone = ({commit}, payload) => {
    commit(types.DONE, payload)
}

export const setProductRawData = function({commit}, payload) {
    commit(types.PRODUCTRAWDATA, payload)
}

export const setFlashTextOrgn = ({commit}, payload) => {
    commit(types.FLASH_TEXT_ORGN, payload)
}

export const setSpaceyOrgn = ({commit}, payload) => {
    commit(types.SPACEY_ORGN, payload)
}
export const setStates = ({commit}, payload) => {
    commit(types.STATES, payload)
}

export const setEmailsItemRefs = ({commit}, payload) => {
    commit(types.EMAILS_ITEM_REFS, payload)
}

export const setSidebar = ({commit}, payload) => {
    commit(types.SIDEBAR, payload)
}

export const setAllowedSectors = ({commit}, payload) => {
    commit(types.ALLOWED_SECTORS, payload)
}

export const setCurrentActiveModule = ({commit}, payload) => {
  //console.log('set');
  commit(types.CURRENT_ACTIVE_MODULE, payload)
}
export const setUserId = ({commit}, payload) => {
  commit(types.USER_ID, payload)
}
export const setBigLoading = ({commit}, payload) => {
    commit(types.BIG_LOADING, payload)
  }
export const setDashboardType = ({commit}, payload) => {
commit(types.DASHBOARD_TYPE, payload)
}
// export const setCheckboxData = ({commit}, payload) => {
//     commit(types.UPDATED_CHECKBOX, payload)
// }